import { useTranslation } from 'react-i18next';
import { changeLanguage } from '../i18n';

// AeroFence (Ireland) shows English with the Irish flag.
const EN_FLAG = import.meta.env.VITE_CLIENT_ID === 'aerofence' ? 'IE' : 'GB';

const languages = [
  { code: 'en', countryCode: EN_FLAG, label: 'English' },
  { code: 'da', countryCode: 'DK', label: 'Dansk' },
  { code: 'fr', countryCode: 'FR', label: 'Français' },
  { code: 'de', countryCode: 'DE', label: 'Deutsch' },
  { code: 'lt', countryCode: 'LT', label: 'Lietuvių' },
] as const;

export type Language = (typeof languages)[number];
type LanguageCode = Language['code'];

const DEFAULT_LANG: LanguageCode = 'en';

function resolveLanguage(raw: string | undefined): LanguageCode {
  // i18next gives us tags like "en-US" / "de-DE" / "lt"; match the primary
  // subtag against our supported codes and fall back to the default.
  const primary = (raw ?? '').toLowerCase().split('-')[0];
  const match = languages.find((l) => l.code === primary);
  return match?.code ?? DEFAULT_LANG;
}

export function useLanguageSelector() {
  const { i18n } = useTranslation();
  const currentLang = resolveLanguage(i18n.language);
  const currentCountryCode =
    languages.find((l) => l.code === currentLang)?.countryCode ?? EN_FLAG;

  return { languages, currentLang, currentCountryCode, changeLanguage };
}
